import React from "react";
import { useLoaderData } from "react-router-dom";

const ProjectDetails = () => {
  const project = useLoaderData();

  return (
    <div className="container mx-auto bg-primary text-white p-6 rounded-2xl shadow-lg">
      {/* Image Section */}
      <div className="overflow-hidden rounded-xl mb-4">
        <img
          src={project.image}
          alt={project.name}
          className="w-full max-w-screen-md mx-auto object-cover rounded-xl transition-transform duration-300 ease-in-out"
        />
      </div>

      {/* Project Details */}
      <h2 className="text-2xl font-primary">{project.name}</h2>
      <p className="text-paragraph mt-2">{project.description}</p>

      <h3 className="mt-4 text-xl font-semibold">
        🔹 {project.titleForKeyPoints}
      </h3>
      <ul className="mt-2 p-3 rounded-2xl bg-tertiary flex flex-col gap-2">
        {project.keyPoints.map((point, index) => (
          <li key={index}>
            <h4 className="text-lg text-accent">{point.title}</h4>
            <p className="text-paragraph ml-8">{point.content}</p>
          </li>
        ))}
      </ul>

      <p className="mt-4 text-lg text-paragraph">{project.conclusion}</p>
    </div>
  );
};
export default ProjectDetails;
